<script>
import TgModal from "@/abc-dsk/components/Modal/TgModal.vue";
import InstitutionsService from "@/common/api/institutions.service";
import InstitutionSelector from "@/components/InstitutionSelector.vue";
import { useAuthStore } from "@/stores";

export default {
  name: "InstitutionsView",
  components: {
    InstitutionSelector,
    TgModal
  },
  data() {
    return {
      institutions: []
    };
  },
  async created() {
    const response = await InstitutionsService.list();
    this.institutions = response.data.data;
  },
  methods: {
    async select(institution) {
      // Update user state
      await useAuthStore().updatePrimaryInstitution(institution.id);

      this.$router.push(this.$route.query.redirectUrl || "/dictionary");
    }
  }
};
</script>

<template>
  <main class="container">
    <TgModal no-fade header="compact" :is-open="true" :prevent-closing="true">
      <InstitutionSelector
        class="px-3 py-5"
        :institutions="institutions"
        @select="select($event)"
      />
    </TgModal>
  </main>
</template>
